import * as React from "react";
const SvgFiRrDriverMan = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-driver-man_svg__a)">
      <path
        fill="#062147"
        d="M12 12c3.309 0 6-2.691 6-6s-2.691-6-6-6-6 2.691-6 6 2.691 6 6 6m0-10c2.206 0 4 1.794 4 4s-1.794 4-4 4-4-1.794-4-4 1.794-4 4-4m9.936 20.89c.061.549-.304 1.11-.996 1.11a1 1 0 0 1-.993-.89A7.983 7.983 0 0 0 12 16a7.983 7.983 0 0 0-7.947 7.11 1 1 0 0 1-1.988-.22A9.983 9.983 0 0 1 12.001 14a9.98 9.98 0 0 1 9.935 8.89m-4.056-.089a1 1 0 1 1-1.96.398A4.01 4.01 0 0 0 12.001 20a4.01 4.01 0 0 0-3.919 3.199 1 1 0 0 1-1.96-.398A6.02 6.02 0 0 1 12.001 18a6.02 6.02 0 0 1 5.879 4.801"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-driver-man_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrDriverMan;
